import React from 'react';
import './ServicesMain.css';

const allHeading = (props) => {
    return (
        <div className="text-center m-auto"  >
           <h1 className = 'tilesEditText'> {props.headline}</h1>
           <div style = {{display : 'flex' , flexDirection : 'column', justifyContent : 'flex-end' , height : '100%'}}>
            </div> 
        </div>
    ) 
}

export default allHeading
